// extracted by mini-css-extract-plugin
export default {"container":"columnActionsForPerson_container__C79TE","cancel":"columnActionsForPerson_cancel__k8Zv4"};